import { useCallback, useMemo } from "react";
import { notify } from "./notify";

export const useNotify = () => {
  const notifyFn = useCallback(
      notify,
    []
  );

  return useMemo(
    () => ({
      notify: notifyFn,
    }),
    [notifyFn]
  );
};
